import React, { Component } from 'react';
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider';
import Handle from './Handle';
import Track from './Track';
import SliderRail from './SliderRail';

const sliderStyle = {  // Give the slider some width
  position: 'relative',
  height: 15,
  margin: 'auto auto auto 5%'
}
const sliderMainStyle = {  // Give the slider some width
  position: 'relative',
  width: '90%',
  height: 15,
  margin: 'auto'
}

export default class CriteriaSlider extends Component {

    onChange = (value) => {
      // console.log("CriteriaSlider onChange " + value);
      this.props.onChange(value);
    }
    onUpdate = (value) => {
      this.props.onUpdate(value);
    }
    onSlideStart = (value) => {
      this.props.onSlideStart(value);
    }
    onSlideEnd = (value) => {
      this.props.onSlideEnd(value);
    }
    render() {
        return (
        <div className="CriteriaSlider">
            <Slider
            rootStyle={this.props.from==='main'?sliderMainStyle:sliderStyle}
            domain={this.props.domain}
            step={this.props.step}
            mode={5}
            values={this.props.value}
            onChange={this.onChange}
            onUpdate={this.onUpdate}
            onSlideStart={this.onSlideStart}
            onSlideEnd={this.onSlideEnd}
            disabled={this.props.disabled}
          >
            <Rail>
              {({ getRailProps }) => (
                <SliderRail getRailProps={getRailProps} />
              )}
            </Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                  {handles.map(handle => (
                    <Handle
                      key={handle.id}
                      handle={handle}
                      disabled={this.props.disabled}
                      getHandleProps={getHandleProps}
                    />
                  ))}
                </div>
              )}
            </Handles>
            <Tracks left={false} right={false}>
              {({ tracks, getTrackProps }) => (
                <div className="slider-tracks">
                  {tracks.map(({ id, source, target }) => (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      disabled={this.props.disabled}
                      getTrackProps={getTrackProps}
                    />
                  ))}
                </div>
              )}
            </Tracks>
          </Slider>

        </div>
        )
    }
}